import { readAccountNumberCookie } from "./cookie";

const getAccountNumber = () => readAccountNumberCookie();

export default getAccountNumber;
